module.exports = __webpack_public_path__ + "static/media/login-step-4.db945c01.png";